
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 21\" id=\"heart_outline_jax_975993ff79079b99b423a314bc27ff16\" ><path d=\"M12.084 4.81c.25-.91.71-1.77 1.424-2.483a5.628 5.628 0 0 1 7.96 7.958l-9.395 9.394-9.394-9.395a5.628 5.628 0 1 1 9.404-5.475z\" stroke-linejoin=\"round\"/></symbol>";
module.exports = sprite.add(image, "heart_outline_jax_975993ff79079b99b423a314bc27ff16");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/heart_outline.svg
// module id = 634
// module chunks = 1